import React from "react";
import { Button, Icon } from "../components/ui";

// data-btn for a section trigger: "<label>-toggle". Section labels are at most
// two words, so the id stays inside the three-word naming rule
// (e.g. internal-details-toggle).
const toggleId = (label) =>
  `${String(label).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}-toggle`;

/**
 * The trigger of a listing-page accordion section (RCSection, the flows'
 * FlowSection, the product selector): a full-width ghost Button carrying the
 * disclosure state (aria-expanded) and a +/− glyph; its `data-btn` id is how
 * tests and callers find a section. The label is plain text on purpose: the
 * legacy `.rc-lp__section-label` rule (still shipped for the Buy Alerts form)
 * would otherwise restyle it in caps.
 * `summary` (optional) rides after the label, e.g. the choice made in a
 * collapsed section.
 */
const SectionTrigger = ({ icon, label, isOpen, onToggle, summary = null }) => (
  <Button
    variant="ghost"
    size="xl"
    fullWidth
    align="start"
    aria-expanded={isOpen}
    data-btn={toggleId(label)}
    leadingIcon={icon}
    trailingIcon={<Icon name={isOpen ? "Minus" : "Plus"} size="sm" />}
    onClick={onToggle}
  >
    {label}
    {summary}
  </Button>
);

export default SectionTrigger;
